import TreeNode from '../../models/TreeNode';
import Scenario from '../../models/Scenario';
import { SuccessCriteria, CriteriaSubject, CriteriaComparison } from '../../models/project/SuccessCriteria';
import TreeCalculator from '../tree/TreeCreator';
import ScenarioCreator from '../scenario/ScenarioCreator';

import * as _ from 'lodash';

let StatisticsCalculator = {
  calculateScenarioStatistics: function (tree: TreeNode[]) {
    return TreeCalculator.walkTreeForScenarios(tree).map(scenario => {
      return ScenarioCreator.createScenario(scenario);
    });
  },

  calculateLikelyWorkEstimate: function (scenarios: Scenario[], safetyMargin: number = 2.0) {
    const min = scenarios.reduce((min, scenario) => { return (scenario.getTimeEstimate() < min) ? scenario.getTimeEstimate() : min; }, 100000000);
    const max = scenarios.reduce((max, scenario) => { return (scenario.getTimeEstimate() > max) ? scenario.getTimeEstimate() : max; }, 0);
    return {
      'min': min * safetyMargin,
      'max': max * safetyMargin
    };
  },

  isWorkEstimateSane(scenarios: Scenario[]) {
    return _.findIndex(scenarios, (scenario) => { return scenario.getTimeEstimate() > 0; }) !== -1;
  },
  
  calculateLikelyProbability: function (scenarios: Scenario[], successCriteria: SuccessCriteria): number {
    const successful = scenarios.filter((scenario) => {
      let success;

      switch (successCriteria.subject) {
        case CriteriaSubject.TIME_ESTIMATE:
          success = scenario.getTimeEstimate() <= successCriteria.amount ? true : false;

          break;
        case CriteriaSubject.CUSTOM_ESTIMATE:
          if (typeof scenario.getCustomEstimate() === undefined) {
            throw 'Scenario does not include custom estimate!';
          } else {
            switch (successCriteria.condition) {
              case CriteriaComparison.LESS_THAN:
                success = scenario.getCustomEstimate() < successCriteria.amount ? true : false;
                break;
              case CriteriaComparison.LESS_THAN_OR_EQUAL:
                success = scenario.getCustomEstimate() <= successCriteria.amount ? true : false;
                break;
              case CriteriaComparison.EQUAL:
                success = scenario.getCustomEstimate() == successCriteria.amount ? true : false;
                break;
              case CriteriaComparison.MORE_THAN_OR_EQUAL:
                success = scenario.getCustomEstimate() >= successCriteria.amount ? true : false;
                break;
              case CriteriaComparison.MORE_THAN:
                success = scenario.getCustomEstimate() > successCriteria.amount ? true : false;
                break;
            }
          }

          break;
      }

      return success;
    });

    return successful.map(s => s.probability).reduce((acc, prob) => { return acc + prob; }, 0.0);
  }
};

export default StatisticsCalculator;


// WEBPACK FOOTER //
// ./src/services/statistics/StatisticsCalculator.ts